import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import Card from '@mui/material/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import CardFooter from 'components/Card/CardFooter.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from 'components/CustomButtons/Button.jsx';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CircularProgress from '@mui/material/CircularProgress';
import GridItem from 'components/Grid/GridItem.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-react/views/extendedFormsStyle.jsx';

const TaskDependencyComp = (props) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState('');
  const [dialogButton, setDialogButton] = useState('');
  const [fieldDisabled, setFieldDisabled] = useState(false);
  const [dialogType, setDialogType] = useState('add');
  const [data, setData] = useState([]);
  const [message, setMessage] = useState('');
  const [id, setID] = useState('');
  const [parentTaskID, setParentTaskID] = useState('');
  const [childTaskID, setChildTaskID] = useState('');

  const { getTasks, getTaskDependencies } = props;
  useEffect(() => {
    getTasks();
    getTaskDependencies();
  }, [getTasks, getTaskDependencies]);

  const handleEditClick = (e) => {
    setID(e[0]);
    setParentTaskID(e[1]);
    setChildTaskID(e[2]);
    setMessage('');
    setDialogTitle('Edit');
    setDialogButton('Save');
    setFieldDisabled(false);
    setDialogType('update');
    setDialogOpen(true);
    props.resetMessage('');
  };
  const handleDeleteClick = (e) => {
    setID(e[0]);
    setParentTaskID(e[1]);
    setChildTaskID(e[2]);
    setMessage('');
    setDialogTitle('Delete');
    setDialogButton('Confirm Delete');
    setFieldDisabled(true);
    setDialogType('delete');
    setDialogOpen(true);
    props.resetMessage('');
  };
  const handleNewClick = (e) => {
    setParentTaskID('');
    setChildTaskID('');
    setMessage('');
    setDialogTitle('Add New');
    setDialogButton('Save');
    setFieldDisabled(false);
    setDialogType('add');
    setDialogOpen(true);
    props.resetMessage('');
  };
  useEffect(() => {
    setMessage(props.message);
    if (props.refreshTaskDependency) {
      props.getTaskDependencies();
      props.getTasks();
      setDialogOpen(false);
    }
    var rowItems = [];
    if (props.task_list.length > 0 && props.taskDependency_list.length > 0) {
      for (let i = 0; i < props.taskDependency_list.length; i++) {
        var colItems = [];
        colItems.push(i + 1);
        var parentTaskObj = props.task_list.find((o) => o.id === props.taskDependency_list[i].parent_task_id);
        colItems.push(parentTaskObj.title);
        var childTaskObj = props.task_list.find((o) => o.id === props.taskDependency_list[i].child_task_id);
        colItems.push(childTaskObj.title);
        if (!props.taskDependency_list[i].auto_generate) {
          colItems.push(
            <div>
              <IconButton
                onClick={handleEditClick.bind(this,
                  [props.taskDependency_list[i].id,
                    props.taskDependency_list[i].parent_task_id,
                    props.taskDependency_list[i].child_task_id,
                  ])}
                title="Edit row"
              >
                {' '}
                <EditIcon />
              </IconButton>
              <IconButton
                onClick={handleDeleteClick.bind(this,
                  [props.taskDependency_list[i].id,
                    props.taskDependency_list[i].parent_task_id,
                    props.taskDependency_list[i].child_task_id,
                  ])}
                title="Delete row"
              >
                {' '}
                <DeleteIcon />
              </IconButton>
            </div>,
          );
        }
        rowItems.push(colItems);
      }
    }
    setData(rowItems);
  }, [props]);

  const handleDialogClose = (e) => {
    setDialogOpen(false);
    setMessage('');
  };
  const handleDialogConfirm = (e) => {
    if (dialogType === 'add') {
      props.createTaskDependency({
        parent_task_id: parentTaskID.toString(),
        child_task_id: childTaskID.toString(),
      });
    } else if (dialogType === 'update') {
      props.updateTaskDependency(id, {
        parent_task_id: parentTaskID.toString(),
        child_task_id: childTaskID.toString(),
      });
    } else if (dialogType === 'delete') {
      props.deleteTaskDependency(id);
    }
  };

  const onParentTaskIDChange = (e) => {
    setParentTaskID(e.target.value);
  };
  const onChildTaskIDChange = (e) => {
    setChildTaskID(e.target.value);
  };

  const { classes } = props;
  const columns = [
    'Serial',
    'Parent Task',
    'Child Task',
    '',
  ];
  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    filter: true,
    selectableRows: 'none',
    rowsPerPage: 100,
    selectToolbarPlacement: 'none',
  };
  return (
    <div>
      {props.requesting && <CircularProgress size={44} style={{ position: 'absolute', top: '50%', left: '50%' }} />}
      <Card>
        <CardHeader color="primary" style={{ textAlign: 'left', paddingTop: '30px' }}>
          <b>Task Dependency</b>
          <p className={classes.cardCategoryWhite}>
            Here is the list showing a set of tasks that are dependent on a specific task. Completion of the parent task will automatically result in the completion of child tasks
          </p>
        </CardHeader>
        <CardBody>
          <MUIDataTable
            title={<Button onClick={handleNewClick.bind(this)} color="primary" title="Create a new Task Dependency" round> New Task Dependency </Button>}
            data={data}
            columns={columns}
            options={options}
          />
          <Dialog fullWidth open={dialogOpen} onClose={handleDialogClose.bind(this)} aria-labelledby="form-dialog-title">
            <DialogContent>
              <Card>
                <CardHeader color="primary" style={{ textAlign: 'left', paddingTop: '30px' }}>
                  <b>{dialogTitle}</b>
                </CardHeader>
                <CardBody>
                  <div style={{ color: 'red', textAlign: 'center' }}>{message}</div>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl fullWidth className={classes.formControl} disabled={fieldDisabled}>
                        <InputLabel id="parentTaskIdLabel">Parent Task</InputLabel>
                        <Select
                          labelId="parentTaskIdLabel"
                          id="parentTaskIdSelect"
                          value={parentTaskID}
                          onChange={onParentTaskIDChange.bind(this)}
                        >
                          {props.task_list.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {props.task_list.find((p) => p.id === item.id).title}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                  <br />
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <FormControl fullWidth className={classes.formControl} disabled={fieldDisabled}>
                        <InputLabel id="childTaskIdLabel">Child Task</InputLabel>
                        <Select
                          labelId="childTaskIdLabel"
                          id="childTaskIdSelect"
                          value={childTaskID}
                          onChange={onChildTaskIDChange.bind(this)}
                        >
                          {props.task_list.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                              {props.task_list.find((p) => p.id === item.id).title}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </GridItem>
                  </GridContainer>
                  <br />
                </CardBody>
                <CardFooter style={{ textAlign: 'left' }} />
              </Card>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDialogClose.bind(this)} color="primary" round>
                Cancel
              </Button>
              <Button onClick={handleDialogConfirm.bind(this)} color="primary" round>
                {dialogButton}
              </Button>
            </DialogActions>
          </Dialog>
        </CardBody>
      </Card>
    </div>
  );
};
export default withStyles(extendedFormsStyle)(TaskDependencyComp);
